// src/Pages/UpdatedUserGroups/CreateUserGroup/CreateUserGroups.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
import EndPoints from "../../../Api/EndPoints";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import "./updatedusergroup.css";

function CreateUserGroups({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const isUpdatingFromTable = useRef(false);
  const [isOpenDetails, setIsOpenDetails] = useState(true);
  const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);

  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeeDetail, setEmployeeDetail] = useState({
    emp_first_name: "",
    emp_middle_name: "",
    emp_last_name: "",
    emp_id: "",
    emp_type: "",
    manager_name: "",
    designation: "",
    department: "",
  });

  const [username, setUsername] = useState("");
  const [usernameAvailable, setUsernameAvailable] = useState(null);
  const [usernameError, setUsernameError] = useState("");
  const [applicationAccess, setApplicationAccess] = useState(null);
  const [selectedUserGroups, setSelectedUserGroups] = useState([]);
  const [userGroupOptions, setUserGroupOptions] = useState([]);
  const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
  const [isOpenAccount, setIsOpenAccount] = useState(true);
  const [allSelectedUserGroupsData, setAllSelectedUserGroupsData] = useState(
    []
  );

  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;

  // NEW: Update selected user groups and store their data
  useEffect(() => {
    if (!isUpdatingFromTable.current) {
      // When dropdown selection changes, update stored data
      const newlySelectedGroups = userGroupOptions.filter((opt) =>
        selectedUserGroups.includes(opt.id)
      );

      // Filter out default groups when storing into allSelectedUserGroupsData as well
      const newlySelectedNonDefault = newlySelectedGroups.filter(
        (g) =>
          !(
            g?.fullData?.default_group === "True" ||
            g?.fullData?.default_group === true ||
            String(g?.fullData?.default_group).toLowerCase() === "true" ||
            g?.fullData?.default_group_flag === 1 ||
            g?.fullData?.default_group_flag === "1"
          )
      );

      setAllSelectedUserGroupsData((prev) => {
        const existingIds = new Set(prev.map((g) => g.id));
        const toAdd = newlySelectedNonDefault.filter(
          (g) => !existingIds.has(g.id)
        );
        return [...prev, ...toAdd];
      });
    }
  }, [selectedUserGroups, userGroupOptions]);

  const handleUsernameChange = (e) => {
    const raw = e.target.value;

    // allow only lowercase letters, numbers, and underscore
    const sanitized = raw.toLowerCase().replace(/[^a-z0-9_]/g, "");
    setUsername(sanitized);
    if (sanitized.length > 0 && sanitized.length < 5) {
      setUsernameError("Too Short");
      return;
    }
    if (/^\d+$/.test(sanitized)) {
      setUsernameError("Username cannot be only numbers");
      return;
    }
    setUsernameError("");
  };

  useEffect(() => {
    if (!username || username.length < 5 || usernameError) {
      setUsernameAvailable(null);
      return;
    }

    const ac = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const res = await fetch(
          `${FULL_API_BASE_URL}/check-username-availability/?username=${encodeURIComponent(
            username
          )}`,
          { signal: ac.signal }
        );

        let text = (await res.text()).trim();
        text = text.replace(/^"+|"+$/g, "");
        setUsernameAvailable(text);
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
        setUsernameAvailable(null);
      }
    }, 300);

    return () => {
      ac.abort();
      clearTimeout(timer);
    };
  }, [username, usernameError]);

  const hint = usernameError ? usernameError : usernameAvailable || "";
  const hintColor = usernameError
    ? "red"
    : !username || username.length < 5
    ? "red"
    : usernameAvailable === "Available"
    ? "green"
    : usernameAvailable
    ? "red"
    : "#424342";

  const toggleAccordionDetails = () => setIsOpenDetails((prev) => !prev);
  const toggleAccordionAddScreens = () => setIsOpenAddScreens((prev) => !prev);

  // -----------------------------
  // FETCH EMPLOYEES (Select Employee) - use search-emp-for-group
  // -----------------------------
  const fetchEmployees = async (searchKey) => {
    if (!searchKey || String(searchKey).trim().length < 2) {
      setEmployeeOptions([]);
      return;
    }

    try {
      const params = new URLSearchParams();
      params.append("search_key", searchKey.trim());
      if (clientBranchId) params.append("client_branch_id", clientBranchId);

      const res = await fetch(
        `${FULL_API_BASE_URL}/search-emp-for-group?${params.toString()}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("other")}`,
          },
        }
      );

      const json = await res.json();
      const arr = Array.isArray(json?.data)
        ? json.data
        : Array.isArray(json)
        ? json
        : [];

      // ✅ SHOW ONLY EMPLOYEES WHERE USER_ID IS NULL
      const filteredArr = arr.filter(
        (emp) => emp.user_id === null || emp.user_id === ""
      );

      const formattedOptions = filteredArr.map((emp) => {
        const name =
          emp.employee_name && String(emp.employee_name).trim().length > 0
            ? emp.employee_name
            : [emp.emp_last_name, emp.emp_first_name, emp.emp_middle_name]
                .filter(Boolean)
                .join(", ") ||
              [emp.emp_first_name, emp.emp_middle_name, emp.emp_last_name]
                .filter(Boolean)
                .join(" ") ||
              emp.user_name ||
              "";

        const staff = emp.staff_number ?? emp.staff_no ?? "N/A";
        const branch = emp.branch_name ?? "";
        return {
          id: emp.emp_id ?? emp.employee_id ?? emp.user_id,
          label: `${name}${staff ? ` (${staff})` : ""}${
            branch ? " - " + branch : ""
          }`,
          fullData: emp,
        };
      });

      setEmployeeOptions(formattedOptions);
    } catch (err) {
      console.error("Error fetching employees (search-emp-for-group):", err);
      setEmployeeOptions([]);
    }
  };

  // robust selection -> details mapping
  useEffect(() => {
    if (!selectedEmployee || selectedEmployee.length === 0) {
      setEmployeeDetail({
        emp_first_name: "",
        emp_middle_name: "",
        emp_last_name: "",
        emp_id: "",
        emp_type: "",
        manager_name: "",
        designation: "",
        department: "",
      });
      return;
    }

    const selId = String(selectedEmployee[0]);

    // try find in current options
    const found = employeeOptions.find((o) => String(o.id) === selId);

    if (found && found.fullData) {
      setEmployeeDetail(found.fullData);
      return;
    }

    // not found — attempt to fetch single employee details if endpoint exists,
    // else create placeholder so UI doesn't show N/A
    (async () => {
      try {
        // try a get-by-id endpoint (adjust path if your API differs)
        const params = new URLSearchParams();
        params.append("emp_id", selId);
        if (clientBranchId) params.append("client_branch_id", clientBranchId);

        const res = await fetch(
          `${FULL_API_BASE_URL}/get-employee-by-id?${params.toString()}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("other")}`,
            },
          }
        );

        const j = await res.json();
        const dataArr = Array.isArray(j?.data)
          ? j.data
          : Array.isArray(j)
          ? j
          : j?.data
          ? [j.data]
          : [];
        const emp = dataArr[0];

        if (emp) {
          // ensure this option is available in dropdown too
          const opt = {
            id: emp.emp_id ?? emp.employee_id ?? emp.user_id,
            label:
              (emp.employee_name && String(emp.employee_name).trim()) ||
              `${emp.emp_first_name || ""} ${emp.emp_middle_name || ""} ${
                emp.emp_last_name || ""
              }`.trim() ||
              emp.user_name ||
              `Employee ${emp.emp_id || emp.employee_id || ""}`,
            fullData: emp,
          };
          setEmployeeOptions((prev = []) => {
            const exists = prev.some((p) => String(p.id) === String(opt.id));
            return exists ? prev : [opt, ...prev];
          });
          setEmployeeDetail(emp);
        } else {
          // fallback placeholder
          setEmployeeDetail((prev) => ({ ...prev, emp_id: selId }));
        }
      } catch (err) {
        // if endpoint doesn't exist or fails, create minimal placeholder
        console.warn("Could not fetch single employee details:", err);
        setEmployeeDetail((prev) => ({ ...prev, emp_id: selId }));
      }
    })();
  }, [selectedEmployee, employeeOptions, clientBranchId]);

  // -----------------------------
  // FETCH USER GROUPS (filter out default groups in UI)
  // -----------------------------
  const fetchUserGroups = async (searchKey) => {
    if (!searchKey || searchKey.trim().length < 1) {
      setUserGroupOptions([]);
      return;
    }

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-all-user-groups-search-key?client_branch_id=${clientBranchId}&user_name=${UserName}&search_key=${encodeURIComponent(
          searchKey
        )}&search_by_screen_report_name=${isUserGroupEnabled}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const result = await response.json();

      if (result.status === 200 && Array.isArray(result.data)) {
        // FILTER OUT default groups (they should not be visible in search results)
        const filtered = result.data.filter(
          (group) =>
            !(
              group?.default_group === "True" ||
              group?.default_group === true ||
              String(group?.default_group).toLowerCase() === "true" ||
              group?.default_group_flag === 1 ||
              group?.default_group_flag === "1"
            )
        );

        const formattedOptions = filtered.map((group) => ({
          id: group.user_group_id,
          label: group.user_group_name,
          fullData: group,
        }));

        setUserGroupOptions(formattedOptions);
      } else {
        setUserGroupOptions([]);
      }
    } catch (error) {
      console.error("Error fetching user groups:", error);
      setUserGroupOptions([]);
    }
  };

  const headers = [
    "User Group ID",
    "User Group Name",
    "Description",
    "Group Owner Name",
    "Status",
  ];

  // Build table data using allSelectedUserGroupsData (previously chosen groups)
  const tableData = (
    Array.isArray(selectedUserGroups) ? selectedUserGroups : []
  )
    .map((groupId) => {
      const opt = allSelectedUserGroupsData.find((o) => o.id === groupId);
      if (!opt || !opt.fullData) return null;
      const g = opt.fullData;
      return [
        groupId,
        g.user_group_name || "---",
        g.user_group_desc || "---",
        g.group_owner_name || "---",
        g.status || 0,
      ];
    })
    .filter(Boolean);

  const handleTableRowSelection = (newSelectedRows) => {
    isUpdatingFromTable.current = true;
    setSelectedUserGroups(newSelectedRows);
    setTimeout(() => {
      isUpdatingFromTable.current = false;
    }, 0);
  };

  const handleDeleteRow = (rowId) => {
    setAllSelectedUserGroupsData((prev) => prev.filter((o) => o.id !== rowId));
    setUserGroupOptions((prev) => prev.filter((o) => o.id !== rowId));
    setSelectedUserGroups((prev) => prev.filter((id) => id !== rowId));
  };

  const handleSaveUser = async () => {
    try {
      if (!selectedEmployee.length || !username || !applicationAccess) {
        const error = "Please fill all mandatory fields";
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>{error}</span>
              </div>
            </div>
          );
          setActiveImg(ErrorIcon);
        }
        return;
      }

      const empId = selectedEmployee[0];

      // Handle Web / Mobile / Both
      const web_user_flag =
        applicationAccess === 1 || applicationAccess === 3 ? 1 : 0;
      const app_user_flag =
        applicationAccess === 2 || applicationAccess === 3 ? 1 : 0;

      const payload = selectedUserGroups;
      const url = `${FULL_API_BASE_URL}/new-user?client_id=${clientId}&emp_id=${empId}&user_name=${username}&web_user_flag=${web_user_flag}&app_user_flag=${app_user_flag}&created_by_user_name=${UserName}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result?.message?.status === 200) {
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>{result.message.message}</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (result?.message?.status === 400) {
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>
                  {result.message.message ||
                    "Username already exists for this employee"}
                </span>
              </div>
            </div>
          );
          setActiveImg(ErrorIcon);
        }
      } else {
        const errorMsg = result?.message?.message || "Failed to create user";
        setIsMessageBoxVisible(true);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>{errorMsg}</span>
              </div>
            </div>
          );
          setActiveImg(ErrorIcon);
        }
      }
    } catch (error) {
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Something went wrong. Please try again.</span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        if (setActiveImg && window.ErrorImg) setActiveImg(window.ErrorImg);
      }
      console.error("Error creating user:", error);
    }
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">User Registration Form</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/user_dashboard")}
          >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSaveUser}>
            SAVE
          </button>
        </div>
      </div>
      <div style={{ width: "490px", marginBottom: "20px" }}>
        <DropdownWithPagination
          label="Select Employee"
          width="100%"
          selected={selectedEmployee}
          setSelected={setSelectedEmployee}
          onSearchInputChange={fetchEmployees}
          options={employeeOptions}
          isRequired={true}
          showSelectAll={false}
          allowMultiple={false}
          itemsPerPage={4}
        />
      </div>

      {/* EMPLOYEE DETAILS */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>EMPLOYEE DETAILS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionDetails}>
            {isOpenDetails ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenDetails && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "10px 60px 20px 20px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="item2">
                  <FormInputs
                    label="Employee Name"
                    value={
                      selectedEmployee.length === 0
                        ? ""
                        : `${employeeDetail.emp_first_name || ""} ${
                            employeeDetail.emp_middle_name || ""
                          } ${employeeDetail.emp_last_name || ""}`.trim() ||
                          employeeDetail.employee_name ||
                          "N/A"
                    }
                    disabled
                  />
                </div>
                <div className="item3">
                  <FormInputs
                    label="Staff Number"
                    value={
                      selectedEmployee.length === 0
                        ? ""
                        : employeeDetail.staff_number ||
                          employeeDetail.staff_no ||
                          "N/A"
                    }
                    disabled
                  />
                </div>
                <div className="item4">
                  <FormInputs
                    label="Department"
                    value={
                      selectedEmployee.length === 0
                        ? ""
                        : employeeDetail.department ||
                          employeeDetail.department_name ||
                          "N/A"
                    }
                    disabled
                  />
                </div>
                <div className="item5">
                  <FormInputs
                    label="Designation"
                    value={
                      selectedEmployee.length === 0
                        ? ""
                        : employeeDetail.designation ||
                          employeeDetail.designation_name ||
                          "N/A"
                    }
                    disabled
                  />
                </div>
                <div className="item6">
                  <FormInputs
                    label="Manager Name"
                    value={
                      selectedEmployee.length === 0
                        ? ""
                        : employeeDetail.manager_name ||
                          employeeDetail.manager ||
                          "N/A"
                    }
                    disabled
                  />
                </div>
                <div>
                  <FormInputs
                    label="Employee Type"
                    value={
                      selectedEmployee.length === 0
                        ? ""
                        : employeeDetail.emp_type ||
                          employeeDetail.emp_type_name ||
                          "N/A"
                    }
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* USER DETAILS */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>USER DETAILS</label>
          </div>
          <div
            className="accordion-btn"
            onClick={() => setIsOpenAccount((prev) => !prev)}
          >
            {isOpenAccount ? (
              <div className="minus" />
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenAccount && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "10px 60px 20px 20px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="grid-item">
                  <label className="user-gr-label">
                    User Name <span className="red-star">*</span>
                  </label>
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="text"
                      value={username}
                      placeholder="Enter new user name for employee"
                      onChange={handleUsernameChange}
                      className="user-gr-input"
                      maxLength={10}
                      autoComplete="off"
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: hintColor,
                      }}
                    >
                      {hint}
                    </span>
                  </div>
                </div>
                <div className="item2">
                  <DropDown
                    label="Application Access"
                    options={[
                      { id: 1, label: "Web Portal" },
                      { id: 2, label: "Mobile Application" },
                      { id: 3, label: "Both" },
                    ]}
                    selected={applicationAccess}
                    setSelected={setApplicationAccess}
                    isRequired={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* USER GROUPS */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>USER GROUPS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionAddScreens}>
            {isOpenAddScreens ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenAddScreens && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div
                  className="item1"
                  style={{ gridColumn: "1 / -1", marginLeft: "20px" }}
                >
                  <DropdownWithPagination
                    label="Search User Group"
                    width="31%"
                    selected={selectedUserGroups}
                    setSelected={setSelectedUserGroups}
                    onSearchInputChange={fetchUserGroups}
                    options={userGroupOptions}
                    isRequired={true}
                    showSelectAll={false}
                    allowMultiple={true}
                    itemsPerPage={4}
                    placeholder={
                      isUserGroupEnabled
                        ? "Type User Group Name or Screen name or Report Name..."
                        : "Type User Group Name"
                    }
                    showLabelCheckbox={true}
                    labelCheckboxChecked={isUserGroupEnabled}
                    onLabelCheckboxChange={setIsUserGroupEnabled}
                    labelCheckboxText="Search by Screen/Report Name"
                  />
                </div>
                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossStudentGroup
                    headers={headers}
                    data={tableData}
                    searchPlaceholder="Search user groups..."
                    selectedRows={selectedUserGroups}
                    setSelectedRows={handleTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteRow}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CreateUserGroups;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
// import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
// import EndPoints from "../../../Api/EndPoints";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import "./updatedusergroup.css";

// function CreateUserGroups({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const isUpdatingFromTable = useRef(false);
//   const [isOpenDetails, setIsOpenDetails] = useState(true);
//   const [isOpenAddScreens, setIsOpenAddScreens] = useState(true);

//   const [selectedEmployee, setSelectedEmployee] = useState([]);
//   const [employeeOptions, setEmployeeOptions] = useState([]);
//   const [employeeDetail, setEmployeeDetail] = useState({
//     emp_first_name: "",
//     emp_middle_name: "",
//     emp_last_name: "",
//     emp_id: "",
//     emp_type: "",
//     manager_name: "",
//     designation: "",
//     department: "",
//   });

//   const [username, setUsername] = useState("");
//   const [usernameAvailable, setUsernameAvailable] = useState(null);
//   const [usernameError, setUsernameError] = useState("");
//   const [applicationAccess, setApplicationAccess] = useState(null);
//   const [selectedUserGroups, setSelectedUserGroups] = useState([]);
//   const [userGroupOptions, setUserGroupOptions] = useState([]);
//   const [isUserGroupEnabled, setIsUserGroupEnabled] = useState(false);
//   const [isOpenAccount, setIsOpenAccount] = useState(true);
//   const [allSelectedUserGroupsData, setAllSelectedUserGroupsData] = useState([]);

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;

//   // const handleUsernameChange = (e) => {
//   //   const raw = e.target.value;
//   //   const sanitized = raw.toLowerCase().replace(/[^a-z0-9_]/g, "");
//   //   setUsername(sanitized);

//   //   if (sanitized.length > 0 && sanitized.length < 5) {
//   //     setUsernameError("Too Short");
//   //   } else {
//   //     setUsernameError("");
//   //   }
//   // };

//   // NEW: Update selected user groups and store their data
//   useEffect(() => {
//     if (!isUpdatingFromTable.current) {
//       // When dropdown selection changes, update stored data
//       const newlySelectedGroups = userGroupOptions.filter(opt =>
//         selectedUserGroups.includes(opt.id)
//       );

//       setAllSelectedUserGroupsData(prev => {
//         const existingIds = new Set(prev.map(g => g.id));
//         const toAdd = newlySelectedGroups.filter(g => !existingIds.has(g.id));
//         return [...prev, ...toAdd];
//       });
//     }
//   }, [selectedUserGroups, userGroupOptions]);

//   const handleUsernameChange = (e) => {
//     const raw = e.target.value;

//     // allow only lowercase letters, numbers, and underscore
//     const sanitized = raw.toLowerCase().replace(/[^a-z0-9_]/g, "");
//     setUsername(sanitized);
//     if (sanitized.length > 0 && sanitized.length < 5) {
//       setUsernameError("Too Short");
//       return;
//     }
//     if (/^\d+$/.test(sanitized)) {
//       setUsernameError("Username cannot be only numbers");
//       return;
//     }
//     setUsernameError("");
//   };

//   useEffect(() => {
//     if (!username || username.length < 5 || usernameError) {
//       setUsernameAvailable(null);
//       return;
//     }

//     const ac = new AbortController();
//     const timer = setTimeout(async () => {
//       try {
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/check-username-availability/?username=${encodeURIComponent(
//             username
//           )}`,
//           { signal: ac.signal }
//         );

//         let text = (await res.text()).trim();
//         text = text.replace(/^"+|"+$/g, "");
//         setUsernameAvailable(text);
//       } catch (err) {
//         if (err.name !== "AbortError") console.error(err);
//         setUsernameAvailable(null);
//       }
//     }, 300);

//     return () => {
//       ac.abort();
//       clearTimeout(timer);
//     };
//   }, [username, usernameError]);

//   const hint = usernameError ? usernameError : usernameAvailable || "";
//   const hintColor = usernameError
//     ? "red"
//     : !username || username.length < 5
//     ? "red"
//     : usernameAvailable === "Available"
//     ? "green"
//     : usernameAvailable
//     ? "red"
//     : "#424342";

//   const toggleAccordionDetails = () => setIsOpenDetails((prev) => !prev);
//   const toggleAccordionAddScreens = () => setIsOpenAddScreens((prev) => !prev);

//   const fetchEmployees = async (searchKey) => {
//     if (!searchKey || searchKey.trim().length < 2) {
//       setEmployeeOptions([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${EndPoints.GetEmployeeBySearchKey}?search_key=${encodeURIComponent(
//           searchKey
//         )}`
//       );
//       const data = await response.json();

//       // if (Array.isArray(data)) {
//       //   const formattedOptions = data.map((emp) => ({
//       //     id: emp.emp_id,
//       //     label: `${emp.emp_first_name || ""} ${emp.emp_middle_name || ""} ${
//       //       emp.emp_last_name || ""
//       //     } (${emp.staff_number || "N/A"})`,
//       //     fullData: emp,
//       //   }));
//       //   setEmployeeOptions(formattedOptions);
//       if (Array.isArray(data)) {
//         // ✅ FILTER employees: only app_user === 1 AND user_id not null
//         const filteredEmployees = data.filter(
//           // (emp) => emp.app_user === 1 && emp.user_id !== null
//           (emp) => emp.app_user === 1 && emp.user_id == null
//         );
//         const formattedOptions = filteredEmployees.map((emp) => ({
//           id: emp.emp_id,
//           label: `${emp.emp_first_name || ""} ${emp.emp_middle_name || ""} ${
//             emp.emp_last_name || ""
//           } (${emp.staff_number || "N/A"})`,
//           fullData: emp,
//         }));

//         setEmployeeOptions(formattedOptions);
//       } else {
//         setEmployeeOptions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching employee data:", error);
//       setEmployeeOptions([]);
//     }
//   };

//   useEffect(() => {
//     if (selectedEmployee.length === 1 && employeeOptions.length > 0) {
//       const found = employeeOptions.find((o) => o.id === selectedEmployee[0]);
//       if (found && found.fullData) {
//         setEmployeeDetail(found.fullData);
//       }
//     }
//   }, [selectedEmployee, employeeOptions]);

//   const fetchUserGroups = async (searchKey) => {
//     if (!searchKey || searchKey.trim().length < 1) {
//       setUserGroupOptions([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-all-user-groups-search-key?client_branch_id=${clientBranchId}&user_name=${UserName}&search_key=${encodeURIComponent(
//           searchKey
//         )}&search_by_screen_report_name=${isUserGroupEnabled}`,
//         {
//           headers: {
//             Accept: "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.status === 200 && Array.isArray(result.data)) {
//         const formattedOptions = result.data.map((group) => ({
//           id: group.user_group_id,
//           label: group.user_group_name,
//           fullData: group,
//         }));
//         setUserGroupOptions(formattedOptions);
//       } else {
//         setUserGroupOptions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching user groups:", error);
//       setUserGroupOptions([]);
//     }
//   };

//   const headers = [
//     "User Group ID",
//     "User Group Name",
//     "Description",
//     "Group Owner Name",
//     "Status",
//   ];

//   // const tableData = (
//   //   Array.isArray(selectedUserGroups) ? selectedUserGroups : []
//   // )
//   //   .map((groupId) => {
//   //     const opt = userGroupOptions.find((o) => o.id === groupId);
//   //     if (!opt || !opt.fullData) return null;
//   //     const g = opt.fullData;
//   //     return [
//   //       groupId,
//   //       g.user_group_name || "---",
//   //       g.user_group_desc || "---",
//   //       g.group_owner_name || "---",
//   //       g.status || 0,
//   //     ];
//   //   })
//   //   .filter(Boolean);

//   // UPDATED: Build table data using allSelectedUserGroupsData instead of userGroupOptions
//   const tableData = (
//     Array.isArray(selectedUserGroups) ? selectedUserGroups : []
//   )
//     .map((groupId) => {
//       const opt = allSelectedUserGroupsData.find((o) => o.id === groupId);  // CHANGED THIS LINE
//       if (!opt || !opt.fullData) return null;
//       const g = opt.fullData;
//       return [
//         groupId,
//         g.user_group_name || "---",
//         g.user_group_desc || "---",
//         g.group_owner_name || "---",
//         g.status || 0,
//       ];
//     })
//     .filter(Boolean);

//   const handleTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromTable.current = true;
//     setSelectedUserGroups(newSelectedRows);
//     setTimeout(() => {
//       isUpdatingFromTable.current = false;
//     }, 0);
//   };

//   // const handleDeleteRow = (rowId) => {
//   //   setUserGroupOptions((prev) => prev.filter((o) => o.id !== rowId));
//   //   setSelectedUserGroups((prev) => prev.filter((id) => id !== rowId));
//   // };

//     const handleDeleteRow = (rowId) => {
//     setAllSelectedUserGroupsData((prev) => prev.filter((o) => o.id !== rowId));
//     setUserGroupOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSelectedUserGroups((prev) => prev.filter((id) => id !== rowId));
//   };

//   const handleSaveUser = async () => {
//     try {
//       if (!selectedEmployee.length || !username || !applicationAccess) {
//         const error = "Please fill all mandatory fields";
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>{error}</span>
//               </div>
//             </div>
//           );
//           setActiveImg(ErrorIcon);
//         }
//         return;
//       }

//       const empId = selectedEmployee[0];

//       // ✅ Handle all 3 cases correctly (Web / Mobile / Both)
//       const web_user_flag =
//         applicationAccess === 1 || applicationAccess === 3 ? 1 : 0;
//       const app_user_flag =
//         applicationAccess === 2 || applicationAccess === 3 ? 1 : 0;

//       const payload = selectedUserGroups;
//       const url = `${FULL_API_BASE_URL}/new-user?client_id=${clientId}&emp_id=${empId}&user_name=${username}&web_user_flag=${web_user_flag}&app_user_flag=${app_user_flag}&created_by_user_name=${UserName}`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();

//       if (result?.message?.status === 200) {
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>{result.message.message}</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//         setTimeout(() => {
//           window.location.reload();
//         }, 1500);
//       } else if (result?.message?.status === 400) {
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>
//                   {result.message.message ||
//                     "Username already exists for this employee"}
//                 </span>
//               </div>
//             </div>
//           );
//           setActiveImg(ErrorIcon);
//         }
//       } else {
//         const errorMsg = result?.message?.message || "Failed to create user";
//         setIsMessageBoxVisible(true);
//         if (setMessageBox) {
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>{errorMsg}</span>
//               </div>
//             </div>
//           );
//           setActiveImg(ErrorIcon);
//         }
//       }
//     } catch (error) {
//       if (setMessageBox) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Something went wrong. Please try again.</span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         if (setActiveImg && window.ErrorImg) setActiveImg(window.ErrorImg);
//       }
//       console.error("Error creating user:", error);
//     }
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">User Registration Form</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/user_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSaveUser}>
//             SAVE
//           </button>
//         </div>
//       </div>
//       <div style={{ width: "490px", marginBottom: "20px" }}>
//         <DropdownWithPagination
//           label="Select Employee"
//           width="100%"
//           selected={selectedEmployee}
//           setSelected={setSelectedEmployee}
//           onSearchInputChange={fetchEmployees}
//           options={employeeOptions}
//           isRequired={true}
//           showSelectAll={false}
//           allowMultiple={false}
//           itemsPerPage={4}
//         />
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>EMPLOYEE DETAILS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionDetails}>
//             {isOpenDetails ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>

//         {isOpenDetails && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "10px 60px 20px 20px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 {/* <div className="item1">
//                   <DropdownWithPagination
//                     label="Select Employee"
//                     width="100%"
//                     selected={selectedEmployee}
//                     setSelected={setSelectedEmployee}
//                     onSearchInputChange={fetchEmployees}
//                     options={employeeOptions}
//                     isRequired={true}
//                     showSelectAll={false}
//                     allowMultiple={false}
//                     itemsPerPage={4}
//                   />
//                 </div> */}
//                 {/* <div></div>
//                 <div></div> */}
//                 <div className="item2">
//                   <FormInputs
//                     label="Employee Name"
//                     value={
//                       selectedEmployee.length === 0
//                         ? ""
//                         : `${employeeDetail.emp_first_name || ""} ${
//                             employeeDetail.emp_middle_name || ""
//                           } ${employeeDetail.emp_last_name || ""}`.trim() ||
//                           "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item3">
//                   <FormInputs
//                     label="Staff Number"
//                     value={
//                       selectedEmployee.length === 0
//                         ? ""
//                         : employeeDetail.staff_number || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item4">
//                   <FormInputs
//                     label="Department"
//                     value={
//                       selectedEmployee.length === 0
//                         ? ""
//                         : employeeDetail.department || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item5">
//                   <FormInputs
//                     label="Designation"
//                     value={
//                       selectedEmployee.length === 0
//                         ? ""
//                         : employeeDetail.designation || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div className="item6">
//                   <FormInputs
//                     label="Manager Name"
//                     value={
//                       selectedEmployee.length === 0
//                         ? ""
//                         : employeeDetail.manager_name || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 <div>
//                   <FormInputs
//                     label="Employee Type"
//                     value={
//                       selectedEmployee.length === 0
//                         ? ""
//                         : employeeDetail.emp_type || "N/A"
//                     }
//                     disabled
//                   />
//                 </div>
//                 {/* <div className="item2">
//                   <DropDown
//                     label="Application Access"
//                     options={[
//                       { id: 1, label: "Web Portal" },
//                       { id: 2, label: "Mobile Application" },
//                       { id: 3, label: "Both" },
//                     ]}
//                     selected={applicationAccess}
//                     setSelected={setApplicationAccess}
//                     isRequired={true}
//                     required
//                   />
//                 </div> */}
//                 {/* <div className="grid-item">
//                   <label className="user-gr-label">
//                     User Name <span className="red-star">*</span>
//                   </label>
//                   <div style={{ position: "relative", width: "100%" }}>
//                     <input
//                       type="text"
//                       value={username}
//                       onChange={handleUsernameChange}
//                       className="user-gr-input"
//                       maxLength={10}
//                       autoComplete="off"
//                     />
//                     <span
//                       style={{
//                         position: "absolute",
//                         right: "10px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         fontSize: "14px",
//                         fontWeight: 500,
//                         color: hintColor,
//                       }}
//                     >
//                       {hint}
//                     </span>
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>USER DETAILS</label>
//           </div>
//           <div
//             className="accordion-btn"
//             onClick={() => setIsOpenAccount((prev) => !prev)}
//           >
//             {isOpenAccount ? (
//               <div className="minus" />
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>

//         {isOpenAccount && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "10px 60px 20px 20px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 <div className="grid-item">
//                   <label className="user-gr-label">
//                     User Name <span className="red-star">*</span>
//                   </label>
//                   <div style={{ position: "relative", width: "100%" }}>
//                     <input
//                       type="text"
//                       value={username}
//                       placeholder="Enter new user name for employee"
//                       onChange={handleUsernameChange}
//                       className="user-gr-input"
//                       maxLength={10}
//                       autoComplete="off"
//                     />
//                     <span
//                       style={{
//                         position: "absolute",
//                         right: "10px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         fontSize: "14px",
//                         fontWeight: 500,
//                         color: hintColor,
//                       }}
//                     >
//                       {hint}
//                     </span>
//                   </div>
//                 </div>
//                 <div className="item2">
//                   <DropDown
//                     label="Application Access"
//                     options={[
//                       { id: 1, label: "Web Portal" },
//                       { id: 2, label: "Mobile Application" },
//                       { id: 3, label: "Both" },
//                     ]}
//                     selected={applicationAccess}
//                     setSelected={setApplicationAccess}
//                     isRequired={true}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>USER GROUPS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionAddScreens}>
//             {isOpenAddScreens ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpenAddScreens && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "20px 0px 20px 0px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 <div
//                   className="item1"
//                   style={{ gridColumn: "1 / -1", marginLeft: "20px" }}
//                 >
//                   <DropdownWithPagination
//                     label="Search User Group"
//                     width="31%"
//                     selected={selectedUserGroups}
//                     setSelected={setSelectedUserGroups}
//                     onSearchInputChange={fetchUserGroups}
//                     options={userGroupOptions}
//                     isRequired={true}
//                     showSelectAll={false}
//                     allowMultiple={true}
//                     itemsPerPage={4}
//                     placeholder={
//                       isUserGroupEnabled
//                         ? "Type User Group Name or Screen name or Report Name..."
//                         : "Type User Group Name"
//                     }
//                     showLabelCheckbox={true}
//                     labelCheckboxChecked={isUserGroupEnabled}
//                     onLabelCheckboxChange={setIsUserGroupEnabled}
//                     labelCheckboxText="Search by Screen/Report Name"
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headers}
//                     data={tableData}
//                     searchPlaceholder="Search user groups..."
//                     selectedRows={selectedUserGroups}
//                     setSelectedRows={handleTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRow}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default CreateUserGroups;

//  <FormInputs
//                       label="User Name"
//                       value={
//                         selectedEmployee.length === 0
//                           ? ""
//                           : employeeDetail.user_name || "N/A"
//                       }
//                       disabled
//                     />
//                     <FormInputs
//                       label="Application Access"
//                       value={
//                         selectedEmployee.length === 0
//                           ? ""
//                           : employeeDetail.web_app_user === undefined
//                           ? "N/A"
//                           : employeeDetail.web_app_user
//                           ? "Yes"
//                           : "No"
//                       }
//                       disabled
//                     />
//                     <FormInputs
//                       label="Mobile App User"
//                       value={
//                         selectedEmployee.length === 0
//                           ? ""
//                           : employeeDetail.mobile_app_user === undefined
//                           ? "N/A"
//                           : employeeDetail.mobile_app_user
//                           ? "Yes"
//                           : "No"
//                       }
//                       disabled
//                     />

{
  /* Username & Access */
}
{
  /* <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "0px 0px 20px 10px" }}
            >
              <div className="grid-two-column">
                <div className="grid-item">
                  <label className="user-gr-label">
                    User Name <span className="red-star">*</span>
                  </label>
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="text"
                      value={username}
                      onChange={handleUsernameChange}
                      className="user-gr-input"
                      maxLength={10}
                      autoComplete="off"
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: hintColor,
                      }}
                    >
                      {hint}
                    </span>
                  </div>
                </div>

                <div className="grid-item">
                  <DropDown
                    label="Application Access"
                    options={[
                      { id: 1, label: "Web Portal" },
                      { id: 2, label: "Mobile Application" },
                      { id: 3, label: "Both" },
                    ]}
                    selected={applicationAccess}
                    setSelected={setApplicationAccess}
                    isRequired={true}
                    required
                  />
                </div>
              </div>
            </div> */
}
